<template>
  <div class="apiDataTable" :style="{height:isLarge?'calc(100% - 0.4rem)':''}" ref="apiDataTable">
    <div class="makerTableContent" :style="{'padding-left':isLeftDrawVisible?'2.6rem':'','padding-right':isRightDrawVisible?'2.6rem':''}">
      <div class="header">
        <div class="left">
          <span class="name">{{layerData.name}}</span>
          <span class="text">（共 <span style="color: white">{{total}}</span> 条记录）</span>
        </div>
        <div class="right">
          <div class="line"></div>
          <el-tooltip content="放大" placement="top" effect="light" @click.native="setLarge(true)" v-if="!isLarge" :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-expand"></Icon>
          </el-tooltip>
          <el-tooltip content="缩小" placement="top" effect="light" @click.native="setLarge(false)" v-else :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-shrink"></Icon>
          </el-tooltip>
          <el-tooltip content="关闭" placement="top" effect="light" @click.native="close" :open-delay="1000" :enterable="false">
            <Icon name="icon-close-bold"></Icon>
          </el-tooltip>
        </div>
      </div>
      <div class="tableBox" @mousewheel="handleScroll">
      <el-table
        v-if="keep"
        v-loading="loading"
        stripe
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
          ref="multipleTable"
          id="multipleTable"
          :data="tableData"
          height="100%"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="loadMore"
          @cell-click="clickItem">
        <!-- <el-table-column
          type="selection"
          class="selection"
          :width="55*zoomFactor">
        </el-table-column> -->
        <el-table-column label="序号" :width="60*zoomFactor">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="标注名称" prop="name" :width="columns && columns.length>9?203*zoomFactor:'auto'" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-for="(item ,index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="columns && columns.length>9?203*zoomFactor:'auto'"
          :formatter="item.formatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <template slot="empty">
          <Empty></Empty>
        </template>
      </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '@/mixins/page'
import * as dataManagement from '@/api/dataManagement'
import { dataset2table, coordTransform } from '@/utils/util'

export default {
  name: 'ApiDataTable',
  props: {
    layerData: {
      type: Object,
      default: null
    }
  },
  mixins: [page],
  inject: ['shared'],
  data () {
    return {
      isLarge: false,
      gisHeader: {},
      columns: [],
      // 所有表格数据
      allTableData: [],
      // 加载表格数据
      tableData: [],

      apiConfig: {},
      isShow: false,
      params: {
        layerId: null,
        pageNumber: 1,
        pageSize: 20
      },
      isNext: false, // 判断是否有下一页
      total: 0,
      loading: false,
      selectedRowId: undefined,
      keep: true
    }
  },
  computed: {
    // _layerData () {
    //   return this.layerData
    // },
    ...mapGetters(['isLeftDrawVisible', 'isRightDrawVisible', 'spaceSearchJeojson', 'apiSourceDatas'])
  },
  mounted () {
    if (this.layerData.dataSourceType !== 'API') {
      return
    }
    this.updateTable()
  },
  watch: {
    layerData (val) {
      if (val.dataSourceType !== 'API') {
        return
      }
      this.updateTable()
    },
    apiSourceDatas: {
      deep: true,
      handler (val) {
        if (val && this.apiConfig) {
          this.updateApiData(val)
        }
      }
    }
  },
  beforeDestroy () {

  },
  methods: {
    handleScroll () {
      const tooltips = document.getElementsByClassName('el-tooltip__popper')
      if (tooltips.length > 0) {
        tooltips[tooltips.length - 1].style.display = 'none'
      }
    },
    setLarge (isLarge) {
      this.isLarge = isLarge
      setTimeout(() => {
        this.reDrawTable()
      }, 300)
    },
    async reDrawTable () {
      this.keep = false
      await this.$nextTick()
      this.keep = true
    },

    // 获取图层属性
    getTableHeader () {
      this.gisHeader = JSON.parse(this.layerData.config)
      this.columns = []
      this.gisHeader.tableProperties.forEach(item => {
        if (item.display === false) {
          return
        }
        this.columns.push({
          prop: item.key.toString(),
          label: item.name,
          type: item.type,
          options: []
        })
      })
      this.columns.push({
        prop: 'marker_lon',
        label: '经度_WGS84',
        type: '',
        options: []
      })
      this.columns.push({
        prop: 'marker_lat',
        label: '纬度_WGS84',
        type: '',
        options: []
      })
      this.columns.push({
        prop: 'marker_height',
        label: '高度_WGS84',
        type: '',
        options: []
      })
    },
    async getApiConfig () {
      const res = await dataManagement.getApiDetails({
        id: this.layerData.dataSourceId
      })
      if (res.code === 200) {
        this.apiConfig = res.data.apiHttpConfig
      }
    },
    updateApiData (datas) {
      this.loading = true
      const data = datas[this.apiConfig.id] ?? {}
      const tableData = dataset2table(data)
      tableData.forEach(item => {
        // 添加标注名称字段
        item.name = item[this.gisHeader.namePropertyId]
        // 经纬高转换
        const postions = coordTransform(this.gisHeader.coordinatesType, [
          item[this.gisHeader.lonHeader],
          item[this.gisHeader.latHeader],
          item[this.gisHeader.heightHeader]
        ])
        item.marker_lon = postions[0]
        item.marker_lat = postions[1]
        item.marker_height = postions[2]
      })
      this.allTableData = tableData
      this.total = this.allTableData.length
      const count = Math.min(this.params.pageNumber * this.params.pageSize, this.allTableData.length)
      this.isNext = count < this.allTableData.length
      this.tableData = this.allTableData.slice(0, count)
      this.loading = false
    },
    // 更新表格
    async updateTable () {
      this.getTableHeader()
      await this.getApiConfig()
      this.updateApiData(this.apiSourceDatas)
    },
    // 刷新表格数据
    refreshTableData () {
      this.updateTable()
    },
    open () {
      this.isShow = true
      this.params.pageNumber = 1
    },
    close () {
      this.$emit('closeMarkerTable')
      this.$emit('updateMarkerTable')
      this.isShow = false
    },
    clickItem (row) {
      const markerId = row[this.gisHeader.markerId]
      this.selectedRowId = markerId
      this.$emit('detailApiMarker', {
        layerId: this.layerData.id,
        id: this.selectedRowId
      })
    },
    // 滚动底部加载更多
    loadMore () {
      if (this.isNext) {
        this.params.pageNumber++
        const count = Math.min(this.params.pageNumber * this.params.pageSize, this.allTableData.length)
        this.isNext = count < this.allTableData.length
        this.tableData = this.allTableData.slice(0, count)
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.apiDataTable{
  width: 100%;
  height: 289px;
  background: #272829;
  box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
  // z-index: 100;
  position: absolute;
  bottom: 0;
  // left: 260px;
  padding: 0 12px 12px 12px;
  box-sizing: border-box;
  transition: all 0.3s;
  .makerTableContent{
    box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
    height: 100%;
  }
  // &[shared]{
  //    width: 1660px !important;
  // }
  .header{
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .name{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .text{
        color: rgba(153, 153, 153, 1);
      }
    }
    .right{
      display: flex;
      align-items: center;
      justify-content: space-between;
      // width: 150px;
      .custom-icon{
        margin-right: 10px;
        >svg{
          color: white !important;
        }
      }
      .line{
        width: 1px;
        height: 14px;
        background: #FFFFFF;
        opacity: 0.1;
        border-radius: 1px;
      }
    }
  }
  .tableBox{
    height: calc(100% - 36px);
    .el-table{
      height: 100%;
      background-color: #272829;
      .el-table__body-wrapper{
        height: calc(100% - 40px) !important;
      }
    }
  }

  .custom-empty {
    margin-bottom: 0px;
  }
}
</style>
